import types from '../../../mutation-types';

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType
) => {
  const { payload: conversationList } = responseData;
  context.commit(types.SET_ALL_CONVERSATION, conversationList);
  // Fetch counts via dedicated /meta endpoint (debounced) instead of
  // piggy-backing on the conversations response. This keeps the index
  // endpoint fast by skipping the GROUP BY count query.
  context.dispatch('conversationStats/get', requestPayload, { root: true });
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.commit(types.CLEAR_LIST_LOADING_STATUS);
  setContacts(context.commit, conversationList);
  // O sync de reconexao (updated_within) NAO e paginacao: ele voltava com
  // <25 itens e marcava FIM FALSO da aba, alem de gravar page=null (que o
  // proximo +1 lia como pagina 1). Com o websocket oscilando, cada blip
  // matava o scroll infinito — o "trava num momento" independente de
  // profundidade. Sync nao toca no paginador.
  if (!requestPayload.updatedWithin) {
    setPageFilter({
      dispatch: context.dispatch,
      filter: filterType,
      page: requestPayload.page,
      // pagina incompleta = ultima pagina: poupa a busca extra da vazia
      markEndReached: conversationList.length < 25,
    });
  }
};
